import AdminLayout from "./AdminLayout";
import AdminUsers from "./AdminUsers";

export default function AdminUsersPage() {
  return (
    <AdminLayout>
      <AdminUsers />
    </AdminLayout>
  );
}
